var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19997 21.1705C3.34511 27.1856 5.23107 33.5153 9.85786 38.1421C16.7868 45.071 27.5348 45.8531 35.3259 40.4884C36.1918 39.8921 36.6248 39.5939 36.8522 39.0576C37.0316 38.6343 37.0459 38.0131 36.8861 37.582C36.6836 37.0357 36.1953 36.6653 35.2188 35.9245L34 35M13.3934 12.6863L12.6497 12.0913C11.7124 11.3415 11.2437 10.9665 11.0536 10.4263C10.9034 9.99935 10.9238 9.38991 11.1023 8.97393C11.3281 8.44767 11.7509 8.15359 12.5964 7.56543C18.6568 3.34983 26.5293 2.87248 33 6.13338M41.8666 15C44.2213 19.6725 44.6268 25.0758 43.0831 30",
    stroke: "#202124",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4374 6.75215C37.5626 6.13991 38.4374 6.13991 38.5625 6.75215C38.8389 8.10434 39.8956 9.16106 41.2478 9.43744C41.86 9.56258 41.86 10.4374 41.2478 10.5625C39.8956 10.8389 38.8389 11.8956 38.5625 13.2478C38.4374 13.86 37.5626 13.86 37.4374 13.2478C37.1611 11.8956 36.1043 10.8389 34.7521 10.5625C34.1399 10.4374 34.1399 9.56258 34.7521 9.43744C36.1043 9.16106 37.1611 8.10434 37.4374 6.75215Z",
    fill: "#5200FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9408 17.2901C23.9539 17.2256 24.0461 17.2256 24.0593 17.2901C24.7438 20.6391 27.361 23.2562 30.71 23.9408C30.7745 23.9539 30.7745 24.0461 30.71 24.0593C27.361 24.7438 24.7438 27.361 24.0593 30.71C24.0461 30.7745 23.9539 30.7745 23.9408 30.71C23.2562 27.361 20.6391 24.7438 17.2901 24.0593C17.2256 24.0461 17.2256 23.9539 17.2901 23.9408C20.6391 23.2562 23.2562 20.6391 23.9408 17.2901Z",
    stroke: "#5200FF",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.2d846abead9512750ba0c9b40ccd1ed6.svg";
export { ForwardRef as ReactComponent };